(function () {
  const NATIVE_PRICE_KEY = /filter\.(v|p)\.price/i;
  const DEBUG_PARAM = 'maison_price_debug';
  const BUCKETS = ['under', 'mid', 'high'];

  const debugState = {
    enabled: false,
    lastRun: null,
    logs: [],
  };

  let cachedBucketCounts = null;
  let refreshPromise = null;
  let refreshAfterUpdateTimer = null;
  let applyingCounts = false;
  let domObserver = null;

  function isDebugEnabled() {
    try {
      if (localStorage.getItem('maison_price_debug') === '1') return true;
    } catch (_e) {}
    return new URLSearchParams(window.location.search).has(DEBUG_PARAM);
  }

  function debugLog(message, data) {
    if (!debugState.enabled) return;
    const entry = {
      t: new Date().toISOString().slice(11, 23),
      message: message,
      data: data || null,
    };
    debugState.logs.push(entry);
    if (debugState.logs.length > 80) debugState.logs.shift();
    renderDebugPanel();
    console.log('[maison-price-filter]', message, data || '');
  }

  function stripNativePriceParams(params) {
    [...params.keys()].forEach(function (key) {
      if (NATIVE_PRICE_KEY.test(key)) {
        params.delete(key);
      }
    });
  }

  function getMaisonPriceRoots() {
    return [...document.querySelectorAll('[data-maison-price-buckets]')];
  }

  function shouldShowPriceCounts() {
    const roots = getMaisonPriceRoots();
    if (!roots.length) {
      return false;
    }
    return roots[0].dataset.maisonPriceShowCounts !== 'false';
  }

  function resolveSectionId(root) {
    const filterable = document.getElementById('filterable');
    if (filterable && typeof getSectionId === 'function') {
      const fromDom = getSectionId(filterable);
      if (fromDom) return fromDom;
    }
    return root.dataset.sectionId || '';
  }

  function parseSectionHtml(html) {
    if (typeof parseDOMFromString === 'function') {
      return parseDOMFromString(html);
    }
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function collectFilterPrices(doc, meta) {
    const scope = doc || document;
    const prices = [];
    const nodes = scope.querySelectorAll('[data-maison-filter-price]');
    nodes.forEach(function (el) {
      const cents = parseInt(el.getAttribute('data-maison-filter-price'), 10);
      if (cents > 100) {
        prices.push(cents);
      }
    });
    if (meta) {
      meta.tilesFound = nodes.length;
      meta.pricesUsed = prices.length;
    }
    return prices;
  }

  function bucketCounts(prices, underCents, midCents) {
    const counts = { under: 0, mid: 0, high: 0 };
    prices.forEach(function (cents) {
      if (cents <= underCents) {
        counts.under += 1;
      } else if (cents <= midCents) {
        counts.mid += 1;
      } else {
        counts.high += 1;
      }
    });
    return counts;
  }

  function updateBucketButton(button, bucket, count) {
    if (!button) {
      return false;
    }

    const span = button.querySelector('[data-price-count="' + bucket + '"]');
    if (span) {
      span.textContent = String(count);
      return true;
    }

    const text = button.textContent || '';
    const next = text.replace(/\([^)]*\)\s*$/, '(' + count + ')');
    if (next !== text) {
      button.textContent = next;
      return true;
    }

    return false;
  }

  function applyCountsToDom(counts) {
    if (!counts) {
      return { spansUpdated: 0, rootsSeen: 0 };
    }

    applyingCounts = true;
    let spansUpdated = 0;

    getMaisonPriceRoots().forEach(function (root) {
      root.removeAttribute('data-maison-price-pending');
      root.dataset.maisonCounts = counts.under + '|' + counts.mid + '|' + counts.high;
    });

    BUCKETS.forEach(function (bucket) {
      const count = counts[bucket];
      document.querySelectorAll('[data-price-count-bucket="' + bucket + '"]').forEach(function (button) {
        if (updateBucketButton(button, bucket, count)) {
          spansUpdated += 1;
        }
        if (count === 0) {
          button.setAttribute('disabled', 'disabled');
          button.classList.add('is-disabled');
        } else {
          button.removeAttribute('disabled');
          button.classList.remove('is-disabled');
        }
      });

      document.querySelectorAll('[data-price-count="' + bucket + '"]').forEach(function (span) {
        span.textContent = String(count);
        spansUpdated += 1;
      });
    });

    applyingCounts = false;
    return {
      spansUpdated: spansUpdated,
      rootsSeen: getMaisonPriceRoots().length,
    };
  }

  function buildSectionFetchUrl(sectionId, page, searchParams) {
    const params = new URLSearchParams(searchParams);
    params.delete('maison_price');
    params.delete(DEBUG_PARAM);
    stripNativePriceParams(params);
    if (page > 1) {
      params.set('page', String(page));
    } else {
      params.delete('page');
    }
    params.set('section_id', sectionId);
    const query = params.toString();
    return query ? window.location.pathname + '?' + query : window.location.pathname;
  }

  function readRootConfig(root) {
    const total = parseInt(root.dataset.collectionProductsCount, 10) || 0;
    const perPage = parseInt(root.dataset.productsPerPage, 10) || 0;
    const datasetPages = parseInt(root.dataset.paginatePages, 10) || 0;
    const calculatedPages = total > 0 && perPage > 0 ? Math.ceil(total / perPage) : 0;
    return {
      sectionId: resolveSectionId(root),
      datasetSectionId: root.dataset.sectionId || '',
      total: total,
      perPage: perPage,
      datasetPages: datasetPages,
      calculatedPages: calculatedPages,
      gridPages: Math.max(datasetPages, calculatedPages, 1),
      underCents: parseInt(root.dataset.priceUnder, 10) * 100,
      midCents: parseInt(root.dataset.priceMid, 10) * 100,
    };
  }

  function getActiveMaisonPriceBucket() {
    const bucket = new URLSearchParams(window.location.search).get('maison_price');
    return BUCKETS.indexOf(bucket) !== -1 ? bucket : '';
  }

  function priceMatchesBucket(cents, bucket, underCents, midCents) {
    if (cents <= 100) {
      return false;
    }
    if (bucket === 'under') {
      return cents <= underCents;
    }
    if (bucket === 'mid') {
      return cents > underCents && cents <= midCents;
    }
    if (bucket === 'high') {
      return cents > midCents;
    }
    return true;
  }

  function readVariantSizePriceBounds() {
    if (!document.querySelector('[data-variant-price-filter]')) {
      return null;
    }
    const params = new URLSearchParams(window.location.search);
    let hasSize = false;
    let gte = null;
    let lte = null;
    params.forEach(function (value, key) {
      const param = key.toLowerCase();
      if (param === 'filter.v.option.size') {
        hasSize = true;
      }
      if (/\.price\.gte$/i.test(param)) {
        gte = parseFloat(value);
      }
      if (/\.price\.lte$/i.test(param)) {
        lte = parseFloat(value);
      }
    });
    if (!hasSize || (gte == null && lte == null)) {
      return null;
    }
    if (gte != null && Number.isNaN(gte)) {
      gte = null;
    }
    if (lte != null && Number.isNaN(lte)) {
      lte = null;
    }
    if (gte == null && lte == null) {
      return null;
    }
    return {
      minCents: gte == null ? 0 : Math.round(gte * 100),
      maxCents: lte == null ? Infinity : Math.round(lte * 100),
    };
  }

  function applyVariantSizePriceFilter(bounds) {
    let visibleCount = 0;
    document.querySelectorAll('#results [data-product-grid-item]').forEach(function (item) {
      const priceEl = item.querySelector('[data-maison-filter-price]');
      const cents = priceEl ? parseInt(priceEl.getAttribute('data-maison-filter-price'), 10) || 0 : 0;
      const show = cents > 100 && cents >= bounds.minCents && cents <= bounds.maxCents;
      item.hidden = !show;
      if (show) {
        item.style.removeProperty('display');
        visibleCount += 1;
      } else {
        item.style.display = 'none';
      }
    });
    debugLog('applyVariantSizePriceFilter', { visibleCount: visibleCount, bounds: bounds });
    return visibleCount;
  }

  let priceAvailabilityToken = 0;

  function sizeFilterSelected() {
    if (!document.querySelector('[data-variant-price-filter]')) {
      return false;
    }
    const params = new URLSearchParams(window.location.search);
    let selected = false;
    params.forEach(function (value, key) {
      if (key.toLowerCase() === 'filter.v.option.size' && String(value).trim() !== '') {
        selected = true;
      }
    });
    return selected;
  }

  function setPriceBucketEnabled(bucket, enabled) {
    document.querySelectorAll('[data-price-bucket="' + bucket + '"]').forEach(function (button) {
      if (button.classList.contains('is-active')) {
        button.removeAttribute('disabled');
        button.classList.remove('is-disabled');
        return;
      }
      if (enabled) {
        button.removeAttribute('disabled');
        button.classList.remove('is-disabled');
      } else {
        button.setAttribute('disabled', 'disabled');
        button.classList.add('is-disabled');
      }
    });
  }

  function resetPriceBucketAvailability() {
    BUCKETS.forEach(function (bucket) {
      setPriceBucketEnabled(bucket, true);
    });
  }

  async function syncVariantPriceBucketAvailability() {
    const token = ++priceAvailabilityToken;
    if (!sizeFilterSelected()) {
      resetPriceBucketAvailability();
      return;
    }

    const root = document.querySelector('[data-variant-price-filter]');
    if (!root) {
      resetPriceBucketAvailability();
      return;
    }

    const under = String(parseInt(root.dataset.priceUnder, 10) || 800);
    const mid = String(parseInt(root.dataset.priceMid, 10) || 1500);
    const gteInput = root.querySelector('[data-price-gte]');
    const lteInput = root.querySelector('[data-price-lte]');
    const gteName = (gteInput && gteInput.name) || 'filter.v.price.gte';
    const lteName = (lteInput && lteInput.name) || 'filter.v.price.lte';
    const sectionId = resolveSectionId(root);
    const ranges = {
      under: { lte: under },
      mid: { gte: under + '.01', lte: mid },
      high: { gte: mid + '.01' },
    };
    const base = new URLSearchParams(window.location.search);
    base.delete('page');
    base.delete('section_id');
    base.delete('maison_price');
    stripNativePriceParams(base);

    await Promise.all(
      BUCKETS.map(async function (bucket) {
        const params = new URLSearchParams(base);
        const range = ranges[bucket];
        if (range.gte) params.set(gteName, range.gte);
        if (range.lte) params.set(lteName, range.lte);
        if (sectionId) params.set('section_id', sectionId);
        const query = params.toString();
        const url = query ? window.location.pathname + '?' + query : window.location.pathname;
        let available = true;
        try {
          const html = await fetch(url, { credentials: 'same-origin' }).then(function (response) {
            if (!response.ok) {
              throw new Error('HTTP ' + response.status);
            }
            return response.text();
          });
          if (token !== priceAvailabilityToken) return;
          available = html.indexOf('data-product-grid-item') !== -1;
        } catch (error) {
          debugLog('price bucket availability failed', { bucket: bucket, message: error && error.message });
          available = true;
        }
        if (token !== priceAvailabilityToken) return;
        setPriceBucketEnabled(bucket, available);
      })
    );
  }

  function applyGridPriceFilter() {
    const variantBounds = readVariantSizePriceBounds();
    if (variantBounds) {
      return applyVariantSizePriceFilter(variantBounds);
    }

    const bucket = getActiveMaisonPriceBucket();
    const roots = getMaisonPriceRoots();
    const config = roots.length ? readRootConfig(roots[0]) : null;
    const underCents = config ? config.underCents : 80000;
    const midCents = config ? config.midCents : 150000;
    let visibleCount = 0;

    document.querySelectorAll('#results [data-product-grid-item]').forEach(function (item) {
      const priceEl = item.querySelector('[data-maison-filter-price]');
      if (!bucket) {
        item.hidden = false;
        item.style.removeProperty('display');
        visibleCount += 1;
        return;
      }
      if (!priceEl) {
        item.hidden = false;
        item.style.removeProperty('display');
        visibleCount += 1;
        return;
      }

      const cents = parseInt(priceEl.getAttribute('data-maison-filter-price'), 10) || 0;
      const show = priceMatchesBucket(cents, bucket, underCents, midCents);
      item.hidden = !show;
      if (show) {
        item.style.removeProperty('display');
        visibleCount += 1;
      } else {
        item.style.display = 'none';
      }
    });

    debugLog('applyGridPriceFilter', { bucket: bucket, visibleCount: visibleCount });
    return visibleCount;
  }

  function syncLoadMoreUrls() {
    const bucket = getActiveMaisonPriceBucket();
    document.querySelectorAll('[data-fragment-id="collection-load-more"]').forEach(function (root) {
      const next = root.getAttribute('data-next-url');
      if (!next) {
        return;
      }
      try {
        const url = new URL(next, window.location.origin);
        if (bucket) {
          url.searchParams.set('maison_price', bucket);
        } else {
          url.searchParams.delete('maison_price');
        }
        const nextPath = url.pathname + url.search;
        root.setAttribute('data-next-url', nextPath);
        const btn = root.querySelector('[data-load-more-next]');
        if (btn) {
          btn.setAttribute('href', nextPath);
        }
      } catch (_e) {}
    });
  }

  function variantPriceRoot(form) {
    return form ? form.querySelector('[data-variant-price-filter]') : null;
  }

  function setVariantPriceInputs(form, bucket) {
    const root = variantPriceRoot(form);
    if (!root) {
      return false;
    }
    const gte = root.querySelector('[data-price-gte]');
    const lte = root.querySelector('[data-price-lte]');
    if (!gte || !lte) {
      return false;
    }
    const under = String(parseInt(root.dataset.priceUnder, 10) || 800);
    const mid = String(parseInt(root.dataset.priceMid, 10) || 1500);
    gte.disabled = true;
    lte.disabled = true;
    gte.value = '';
    lte.value = '';
    if (bucket === 'under') {
      lte.disabled = false;
      lte.value = under;
    } else if (bucket === 'mid') {
      gte.disabled = false;
      gte.value = under + '.01';
      lte.disabled = false;
      lte.value = mid;
    } else if (bucket === 'high') {
      gte.disabled = false;
      gte.value = mid + '.01';
    }
    return true;
  }

  function migrateLegacyPriceFilter(root) {
    if (document.querySelector('[data-variant-price-filter]')) {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    if (params.has('maison_price')) {
      return;
    }

    let gte = null;
    let lte = null;
    params.forEach(function (value, key) {
      if (/\.price\.gte$/i.test(key) || /filter\.v\.price\.gte/i.test(key)) {
        gte = parseFloat(value);
      }
      if (/\.price\.lte$/i.test(key) || /filter\.v\.price\.lte/i.test(key)) {
        lte = parseFloat(value);
      }
    });

    if (gte == null && lte == null) {
      return;
    }

    const under = parseInt(root.dataset.priceUnder, 10);
    const mid = parseInt(root.dataset.priceMid, 10);
    let bucket = '';

    if (gte == null && lte === under) {
      bucket = 'under';
    } else if (gte === under && lte === mid) {
      bucket = 'mid';
    } else if (gte === mid && lte == null) {
      bucket = 'high';
    }

    stripNativePriceParams(params);
    if (bucket) {
      params.set('maison_price', bucket);
    }

    const next = params.toString();
    window.location.replace(next ? window.location.pathname + '?' + next : window.location.pathname);
  }

  function prepareFilterForms() {
    document.querySelectorAll('form').forEach(function (form) {
      if (!form.querySelector('[data-maison-price-input]')) {
        return;
      }
      form.addEventListener(
        'submit',
        function () {
          form.querySelectorAll('input[name*="price"]').forEach(function (input) {
            if (
              input.hasAttribute('data-maison-price-input') ||
              input.hasAttribute('data-price-gte') ||
              input.hasAttribute('data-price-lte')
            ) {
              return;
            }
            if (NATIVE_PRICE_KEY.test(input.name)) {
              input.disabled = true;
            }
          });
        },
        true
      );
    });
  }

  function clearMaisonPriceInputs(form) {
    if (!form) {
      return;
    }
    setVariantPriceInputs(form, '');
    const input = form.querySelector('[data-maison-price-input]');
    if (input) {
      input.value = '';
      input.disabled = true;
    }
  }

  function setMaisonPriceInput(form, bucket) {
    if (!form) {
      return;
    }
    if (variantPriceRoot(form)) {
      setVariantPriceInputs(form, bucket);
      const maisonInput = form.querySelector('[data-maison-price-input]');
      if (maisonInput) {
        maisonInput.value = '';
        maisonInput.disabled = true;
      }
      return;
    }
    const input = form.querySelector('[data-maison-price-input]');
    if (!input) {
      return;
    }
    input.disabled = false;
    input.value = bucket || '';
    if (!bucket) {
      input.disabled = true;
    }
  }

  function ensureDebugPanel() {
    if (!debugState.enabled) return null;
    let panel = document.getElementById('maison-price-debug-panel');
    if (panel) return panel;

    panel = document.createElement('aside');
    panel.id = 'maison-price-debug-panel';
    panel.setAttribute('aria-label', 'Maison price filter debug');
    panel.innerHTML =
      '<style>' +
      '#maison-price-debug-panel{position:fixed;bottom:12px;left:12px;z-index:99999;width:min(420px,calc(100vw - 24px));max-height:min(70vh,520px);overflow:auto;' +
      'background:#1a1410;color:#f5efe6;font:11px/1.45 ui-monospace,monospace;border:1px solid rgba(245,239,230,.25);box-shadow:0 8px 32px rgba(0,0,0,.35);}' +
      '#maison-price-debug-panel header{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:10px 12px;border-bottom:1px solid rgba(245,239,230,.15);' +
      'position:sticky;top:0;background:#1a1410;}' +
      '#maison-price-debug-panel h2{margin:0;font-size:10px;letter-spacing:.14em;text-transform:uppercase;font-weight:600;}' +
      '#maison-price-debug-panel button{background:transparent;border:1px solid rgba(245,239,230,.35);color:inherit;padding:4px 8px;cursor:pointer;font:inherit;}' +
      '#maison-price-debug-panel dl{margin:0;padding:10px 12px;display:grid;grid-template-columns:auto 1fr;gap:4px 10px;}' +
      '#maison-price-debug-panel dt{opacity:.65;}#maison-price-debug-panel dd{margin:0;word-break:break-all;}' +
      '#maison-price-debug-panel pre{margin:0;padding:10px 12px;border-top:1px solid rgba(245,239,230,.12);white-space:pre-wrap;word-break:break-word;}' +
      '</style>' +
      '<header><h2>Maison price filter debug</h2><button type="button" data-maison-price-debug-close>Close</button></header>' +
      '<dl data-maison-price-debug-meta></dl>' +
      '<pre data-maison-price-debug-log></pre>';

    document.body.appendChild(panel);
    panel.querySelector('[data-maison-price-debug-close]').addEventListener('click', function () {
      panel.hidden = true;
    });
    return panel;
  }

  function setDebugRun(partial) {
    debugState.lastRun = Object.assign({}, debugState.lastRun || {}, partial);
    if (debugState.enabled) {
      renderDebugPanel();
    }
  }

  function renderDebugPanel() {
    if (!debugState.enabled) return;
    const panel = ensureDebugPanel();
    if (!panel) return;

    panel.hidden = false;
    const meta = panel.querySelector('[data-maison-price-debug-meta]');
    const logEl = panel.querySelector('[data-maison-price-debug-log]');
    const run = debugState.lastRun || {};
    const rootsNow = getMaisonPriceRoots().length;
    const countTargetsNow = document.querySelectorAll('[data-price-count]').length;

    meta.innerHTML =
      '<dt>Status</dt><dd>' +
      (run.error ? 'ERROR' : run.updated ? 'Updated UI' : run.earlyExit ? run.earlyExit : rootsNow ? 'Running…' : 'Waiting for price filter DOM') +
      '</dd>' +
      '<dt>Script</dt><dd>loaded</dd>' +
      '<dt>Roots now</dt><dd>' + rootsNow + '</dd>' +
      '<dt>Count targets</dt><dd>' + countTargetsNow + '</dd>' +
      '<dt>Section ID</dt><dd>' + (run.sectionId || '—') + '</dd>' +
      '<dt>Products count</dt><dd>' + (run.total != null ? run.total : '—') + '</dd>' +
      '<dt>Per page</dt><dd>' + (run.perPage != null ? run.perPage : '—') + '</dd>' +
      '<dt>Grid pages</dt><dd>' +
      (run.gridPages != null
        ? run.gridPages + ' (dataset: ' + run.datasetPages + ', calc: ' + run.calculatedPages + ')'
        : '—') +
      '</dd>' +
      '<dt>Under / mid</dt><dd>' +
      (run.underCents ? '$' + run.underCents / 100 + ' / $' + run.midCents / 100 : '—') +
      '</dd>' +
      '<dt>Prices collected</dt><dd>' + (run.allPricesCount != null ? run.allPricesCount : '—') + '</dd>' +
      '<dt>Computed</dt><dd>' +
      (run.computedCounts
        ? run.computedCounts.under + ' / ' + run.computedCounts.mid + ' / ' + run.computedCounts.high
        : '—') +
      '</dd>' +
      '<dt>DOM targets</dt><dd>' +
      (run.spansUpdated != null ? run.spansUpdated + ' updated, ' + run.rootsSeen + ' roots' : '—') +
      '</dd>' +
      (run.error ? '<dt>Error</dt><dd>' + run.error + '</dd>' : '');

    const pageLines = (run.pageStats || []).map(function (p) {
      return 'p' + p.page + ': tiles=' + p.tilesFound + ' prices=' + p.pricesUsed;
    });
    const logLines = debugState.logs.slice(-20).map(function (e) {
      return e.t + ' ' + e.message + (e.data ? ' ' + JSON.stringify(e.data) : '');
    });
    logEl.textContent = (pageLines.length ? pageLines.join('\n') + '\n\n' : '') + logLines.join('\n');
  }

  function scheduleApplyCachedCounts() {
    if (!cachedBucketCounts) {
      return;
    }
    requestAnimationFrame(function () {
      const result = applyCountsToDom(cachedBucketCounts);
      debugLog('re-applied cached counts', result);
    });
  }

  function ensureDomObserver() {
    if (typeof MutationObserver === 'undefined') {
      return;
    }

    if (domObserver) {
      return;
    }

    domObserver = new MutationObserver(function (mutations) {
      if (applyingCounts || !cachedBucketCounts) {
        return;
      }
      for (let i = 0; i < mutations.length; i += 1) {
        const mutation = mutations[i];
        if (mutation.type !== 'childList') {
          continue;
        }
        const target = mutation.target;
        if (
          target.closest &&
          (target.closest('[data-filterable-filter-fragment]') ||
            target.closest('[data-maison-price-buckets]') ||
            target.matches('[data-maison-price-buckets]'))
        ) {
          scheduleApplyCachedCounts();
          break;
        }
      }
    });

    ['filters-form-filters-drop-down', 'filters-form-drawer'].forEach(function (formId) {
      const form = document.getElementById(formId);
      if (form) {
        domObserver.observe(form, { childList: true, subtree: true });
      }
    });
  }

  async function refreshPriceBucketCounts() {
    if (refreshPromise) {
      return refreshPromise;
    }

    refreshPromise = (async function () {
      const roots = getMaisonPriceRoots();
      const run = {
        rootsCount: roots.length,
        pageStats: [],
        allPricesCount: 0,
        updated: false,
        spansUpdated: 0,
        rootsSeen: roots.length,
        earlyExit: '',
        error: '',
      };

      debugLog('refresh start', { roots: roots.length });

      if (!roots.length) {
        run.earlyExit = 'no [data-maison-price-buckets] in DOM';
        debugState.lastRun = run;
        renderDebugPanel();
        return run;
      }

      const config = readRootConfig(roots[0]);
      Object.assign(run, config);

      if (!config.sectionId) {
        run.earlyExit = 'missing sectionId';
        debugState.lastRun = run;
        renderDebugPanel();
        return run;
      }
      if (!config.underCents || !config.midCents) {
        run.earlyExit = 'missing bucket thresholds';
        debugState.lastRun = run;
        renderDebugPanel();
        return run;
      }

      roots.forEach(function (root) {
        root.dataset.countsLoading = 'true';
      });

      try {
        const baseParams = new URLSearchParams(window.location.search);
        let allPrices = [];

        for (let page = 1; page <= config.gridPages; page += 1) {
          const pageMeta = { page: page, fetched: true, tilesFound: 0, pricesUsed: 0 };
          const url = buildSectionFetchUrl(config.sectionId, page, baseParams);
          debugLog('fetch page', { page: page, url: url });
          const html = await fetch(url, { credentials: 'same-origin' }).then(function (response) {
            if (!response.ok) {
              throw new Error('HTTP ' + response.status + ' for page ' + page);
            }
            return response.text();
          });
          const doc = parseSectionHtml(html);
          pageMeta.htmlLength = html.length;
          pageMeta.hasFilterPriceAttr = html.indexOf('data-maison-filter-price') !== -1;
          const pagePrices = collectFilterPrices(doc, pageMeta);
          run.pageStats.push(pageMeta);
          allPrices = allPrices.concat(pagePrices);
          debugLog('page collected', pageMeta);
        }

        run.allPricesCount = allPrices.length;
        const counts = bucketCounts(allPrices, config.underCents, config.midCents);
        run.computedCounts = counts;

        if (allPrices.length > 0) {
          cachedBucketCounts = counts;
          const applyResult = applyCountsToDom(counts);
          run.spansUpdated = applyResult.spansUpdated;
          run.rootsSeen = applyResult.rootsSeen;
          run.updated = applyResult.spansUpdated > 0;
          debugLog('counts applied', applyResult);

          if (!run.updated) {
            run.earlyExit = 'computed counts but no [data-price-count] targets found';
            scheduleApplyCachedCounts();
          }
        } else {
          run.earlyExit = 'no prices collected from any page';
        }
      } catch (error) {
        run.error = error && error.message ? error.message : String(error);
        debugLog('error', { message: run.error });
        console.warn('[maison-price-filter] bucket count refresh failed', error);
      } finally {
        roots.forEach(function (root) {
          if (root.isConnected) {
            root.dataset.countsLoading = 'false';
          }
        });
        debugState.lastRun = run;
        renderDebugPanel();
      }

      return run;
    })();

    try {
      return await refreshPromise;
    } finally {
      refreshPromise = null;
    }
  }

  let bootObserver = null;
  let bootPollTimer = null;
  let booted = false;

  function bootPriceFilter(forceRefresh) {
    debugState.enabled = isDebugEnabled();
    if (debugState.enabled) {
      ensureDebugPanel();
      renderDebugPanel();
    }

    ensureDomObserver();

    const roots = getMaisonPriceRoots();
    if (!roots.length) {
      setDebugRun({ earlyExit: 'waiting for [data-maison-price-buckets]', rootsSeen: 0 });
      debugLog('boot: no price bucket roots yet');
      return false;
    }

    if (!booted) {
      migrateLegacyPriceFilter(roots[0]);
      prepareFilterForms();
      booted = true;
      debugLog('boot: roots found', { count: roots.length });
    }

    if (cachedBucketCounts && shouldShowPriceCounts()) {
      scheduleApplyCachedCounts();
    }

    if (shouldShowPriceCounts()) {
      if (forceRefresh && !refreshPromise) {
        refreshPriceBucketCounts();
      } else if (!cachedBucketCounts && !refreshPromise) {
        refreshPriceBucketCounts();
      }
    }

    applyGridPriceFilter();
    syncLoadMoreUrls();
    syncVariantPriceBucketAvailability();

    return true;
  }

  function watchForPriceFilterDom() {
    if (getMaisonPriceRoots().length) {
      bootPriceFilter(false);
      return;
    }

    const filterable = document.getElementById('filterable');
    if (filterable && !bootObserver) {
      bootObserver = new MutationObserver(function () {
        if (getMaisonPriceRoots().length) {
          bootObserver.disconnect();
          bootObserver = null;
          bootPriceFilter(false);
        }
      });
      bootObserver.observe(filterable, { childList: true, subtree: true });
    }

    if (!bootPollTimer) {
      let attempts = 0;
      bootPollTimer = window.setInterval(function () {
        attempts += 1;
        if (bootPriceFilter(false) || attempts >= 120) {
          window.clearInterval(bootPollTimer);
          bootPollTimer = null;
        }
      }, 500);
    }
  }

  function initMaisonPriceFilter() {
    document.documentElement.setAttribute('data-maison-price-filter', 'loaded');
    debugState.enabled = isDebugEnabled();
    debugLog('init');
    if (!bootPriceFilter(false)) {
      watchForPriceFilterDom();
    }
  }

  function whenReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  }

  whenReady(initMaisonPriceFilter);
  window.addEventListener('load', function () {
    bootPriceFilter(false);
  });

  document.addEventListener('alpine:initialized', function () {
    ensureDomObserver();
    bootPriceFilter(false);
  });

  document.addEventListener('baseline:collection:results-updated', function () {
    debugLog('baseline:collection:results-updated');
    applyGridPriceFilter();
    syncLoadMoreUrls();
    syncVariantPriceBucketAvailability();
    if (!shouldShowPriceCounts()) {
      return;
    }
    bootPriceFilter(false);
    scheduleApplyCachedCounts();
    clearTimeout(refreshAfterUpdateTimer);
    refreshAfterUpdateTimer = window.setTimeout(function () {
      refreshPriceBucketCounts();
    }, 50);
  });

  document.addEventListener(
    'click',
    function (event) {
      if (!cachedBucketCounts) {
        return;
      }
      if (event.target.closest('[data-price-bucket], [data-price-count-bucket], .collection-filter-bar__trigger')) {
        scheduleApplyCachedCounts();
      }
    },
    true
  );

  window.maisonPriceFilter = {
    clearMaisonPriceInputs: clearMaisonPriceInputs,
    setMaisonPriceInput: setMaisonPriceInput,
    hasVariantSizePrice: function () {
      return readVariantSizePriceBounds() != null;
    },
    refreshPriceBucketCounts: refreshPriceBucketCounts,
    stripNativePriceParams: stripNativePriceParams,
    applyGridPriceFilter: applyGridPriceFilter,
    syncLoadMoreUrls: syncLoadMoreUrls,
    enableDebug: function () {
      try {
        localStorage.setItem('maison_price_debug', '1');
      } catch (_e) {}
      debugState.enabled = true;
      ensureDebugPanel();
      renderDebugPanel();
      bootPriceFilter(true);
    },
  };

  window.maisonPriceFilterDebug = debugState;
})();
